export const PAYMENT_DETAILS_ACCORDION_TOGGLE = 'PAYMENT_DETAILS_ACCORDION_TOGGLE';
export const TAXES_ACCORDION_TOGGLE = 'TAXES_ACCORDION_TOGGLE';
export const FEES_ACCORDION_TOGGLE = 'FEES_ACCORDION_TOGGLE';
export const LIENHOLDER_ACCORDION_TOGGLE = 'LIENHOLDER_ACCORDION_TOGGLE';
export const OPEN_PROGRAMS_SLIDEOUT = 'OPEN_PROGRAMS_SLIDEOUT';
export const CLOSE_PROGRAMS_SLIDEOUT = 'CLOSE_PROGRAMS_SLIDEOUT';
export const SET_PROGRAMS_CALC_ENDPOINT_STASH = 'SET_PROGRAMS_CALC_ENDPOINT_STASH';
export const DEAL_TYPE_OVERRIDDEN = 'DEAL_TYPE_OVERRIDDEN';
export const DISMISS_DEAL_TYPE_OVERRIDE = 'DISMISS_DEAL_TYPE_OVERRIDE';
